var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"ufv-container-pages"},[(_vm.tela != null)?_c('ViewTela',{attrs:{"servicoAtendimento":_vm.servicoAtendimento}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }